function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M81.3631 125.382V137.957H71.4377C70.9263 137.957 70.4357 138.16 70.0741 138.521C69.7124 138.882 69.5093 139.371 69.5093 139.882C69.5093 140.393 69.7124 140.882 70.0741 141.243C70.4357 141.604 70.9263 141.807 71.4377 141.807H81.3631V152.404C81.3631 152.914 81.5663 153.404 81.9279 153.765C82.2896 154.126 82.7801 154.329 83.2916 154.329C83.803 154.329 84.2935 154.126 84.6552 153.765C85.0168 153.404 85.22 152.914 85.22 152.404V141.878H95.1454C95.6569 141.878 96.1474 141.675 96.509 141.314C96.8707 140.953 97.0739 140.463 97.0739 139.953C97.0739 139.442 96.8707 138.952 96.509 138.591C96.1474 138.23 95.6569 138.028 95.1454 138.028H85.3085V125.382C92.0958 124.884 98.4252 121.778 102.965 116.717C107.506 111.656 109.903 105.035 109.653 98.2458C109.403 91.4568 106.526 85.0289 101.626 80.3141C96.7262 75.5993 90.1857 72.9648 83.38 72.9648C76.5743 72.9648 70.0338 75.5993 65.134 80.3141C60.2341 85.0289 57.3567 91.4568 57.107 98.2458C56.8572 105.035 59.2545 111.656 63.7947 116.717C68.3349 121.778 74.6642 124.884 81.4516 125.382H81.3631ZM83.2916 76.8502C87.7286 76.8502 92.0659 78.1636 95.7551 80.6243C99.4444 83.0849 102.32 86.5824 104.018 90.6744C105.716 94.7664 106.16 99.2691 105.294 103.613C104.429 107.957 102.292 111.947 99.1547 115.079C96.0173 118.211 92.0199 120.344 87.6682 121.208C83.3165 122.072 78.8057 121.629 74.7065 119.934C70.6073 118.239 67.1036 115.368 64.6385 111.686C62.1734 108.003 60.8577 103.673 60.8577 99.2442C60.8671 93.3078 63.2336 87.6172 67.4388 83.4196C71.6439 79.2219 77.3446 76.8595 83.2916 76.8502Z",
  fill: "url(#paint0_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M161.384 139.459C164.715 133.724 165.741 126.942 164.257 120.481C162.773 114.02 158.888 108.362 153.387 104.649L166.214 82.3609L168.16 95.2711C168.232 95.725 168.464 96.1383 168.815 96.4363C169.165 96.7342 169.611 96.8973 170.071 96.8959H170.354C170.609 96.8614 170.853 96.7765 171.075 96.6463C171.296 96.516 171.489 96.343 171.642 96.1374C171.795 95.9318 171.906 95.6977 171.967 95.4488C172.028 95.2 172.04 94.9414 171.999 94.6883L169.204 76.3386C169.17 76.0459 169.07 75.7648 168.91 75.5171C168.75 75.2694 168.535 75.0616 168.282 74.9097C168.029 74.7579 167.745 74.666 167.451 74.6412C167.156 74.6164 166.861 74.6594 166.586 74.7668L149.283 81.6192C148.887 81.8533 148.588 82.2209 148.44 82.6557C148.292 83.0905 148.304 83.5639 148.475 83.9903C148.646 84.4167 148.964 84.768 149.372 84.981C149.779 85.1939 150.25 85.2543 150.698 85.1514L162.87 80.3829L149.99 102.724C143.866 99.7637 136.831 99.2905 130.364 101.404C123.898 103.517 118.505 108.053 115.321 114.055C112.137 120.057 111.409 127.059 113.292 133.586C115.175 140.113 119.521 145.656 125.416 149.049C128.407 150.781 131.711 151.907 135.139 152.363C138.568 152.818 142.052 152.594 145.393 151.703C148.734 150.813 151.867 149.272 154.611 147.171C157.355 145.07 159.656 142.449 161.384 139.459ZM127.326 145.728C123.48 143.512 120.378 140.207 118.414 136.231C116.449 132.255 115.71 127.787 116.29 123.392C116.87 118.996 118.743 114.871 121.671 111.539C124.6 108.206 128.453 105.815 132.743 104.668C137.033 103.522 141.567 103.671 145.772 105.097C149.977 106.523 153.664 109.162 156.366 112.681C159.069 116.199 160.665 120.438 160.954 124.862C161.242 129.286 160.21 133.695 157.987 137.534C156.528 140.096 154.573 142.344 152.236 144.146C149.898 145.948 147.226 147.269 144.373 148.031C141.521 148.793 138.545 148.982 135.618 148.587C132.692 148.192 129.873 147.22 127.326 145.728Z",
  fill: "url(#paint1_linear)"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.2002 44.5859C33.6877 32.3121 45.5906 22.1134 59.1739 14.6198C72.7573 7.12624 87.7326 2.49678 103.175 1.01734C118.618 -0.462101 134.2 1.23989 148.959 6.01821C163.718 10.7965 177.34 18.5497 188.986 28.799C200.631 39.0483 210.051 51.5761 216.666 65.6087C223.28 79.6413 226.947 94.8808 227.441 110.386C227.934 125.892 225.244 141.334 219.537 155.759C213.829 170.184 205.225 183.286 194.255 194.255",
  stroke: "url(#paint2_linear)",
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M145.061 223.165C125.177 228.823 104.125 228.942 84.1778 223.51C64.2307 218.078 46.1461 207.3 31.8762 192.342C17.6063 177.383 7.69312 158.811 3.20673 138.63C-1.27966 118.449 -0.168843 97.4257 6.41928 77.8299",
  stroke: "url(#paint3_linear)",
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 50.4492,
  y1: 95.1439,
  x2: 118.525,
  y2: 104.205,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 104.72,
  y1: 95.8851,
  x2: 181.542,
  y2: 108.013,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 256.79,
  y1: 165.848,
  x2: -31.3979,
  y2: 106.493,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: -28.7899,
  y1: 62.1504,
  x2: 259.398,
  y2: 121.505,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 115,
  height: 81.2931,
  fill: "white",
  transform: "translate(57 73)"
})));

function SvgGender(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 228,
    viewBox: "0 0 228 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGender);
export default __webpack_public_path__ + "static/media/gender.9a4520a1.svg";
export { ForwardRef as ReactComponent };